export default __webpack_public_path__ + "static/media/autosend-message-image.4da6fe3b.webp";